import React from 'react';
import { Field } from 'formik';
import { Typography } from '@material-tailwind/react';
import { seleccionarTextoInput } from '../../Helpers/utilidades-globales';

export const TabDatosInstitucionales = ({ values, esVisualizacion, setFieldValue, setActiveTab }) => {
     const handlePermitirMinistrosChange = (event) => {
          const permiteMinistros = event.target.checked;

          setFieldValue('ente_dependiente', permiteMinistros);

          if (!permiteMinistros) {
               setActiveTab('datos_institucionales');
          }
     };

    return (
        <div className="bg-white p-5 rounded-md text-sm">
            <div className="flex justify-between items-end">
                 <div className="flex f-col flex-1 max-w-xl">
                      <Typography variant="small" color="blue-gray" className="mb-1 font-medium">Sitio web</Typography>
                      <Field name="pag_web" type="text" maxLength="200" disabled={esVisualizacion} onFocus={() => seleccionarTextoInput("abm-pag_web")} onClick={() => seleccionarTextoInput("abm-pag_web")} id="abm-pag_web" className={`input-ui-data ${values.pag_web ? 'input-cvalor' : 'input-vacio'}`} />
                 </div>
            </div>
            
            <div className="flex flex-row items-center gap-6 mt-4">
                 <div className="flex f-col w-48">
                      <Typography variant="small" color="blue-gray" className="mb-1 font-medium">Cantidad de miembros</Typography>
                      <Field name="cant_miembros" type="number" min="0" disabled={esVisualizacion} onFocus={() => seleccionarTextoInput("abm-cant_miembros")} onClick={() => seleccionarTextoInput("abm-cant_miembros")} id="abm-cant_miembros" className={`input-ui-data ${values.cant_miembros > 0 ? 'input-cvalor' : 'input-vacio'}`} />
                 </div>
                 
                 <div className="flex f-row items-center mt-4 pt-1">
                      <Field
                          id="abm-ente_dependiente"
                          type="checkbox"
                          disabled={esVisualizacion}
                          name="ente_dependiente"
                          checked={Boolean(values.ente_dependiente)}
                          onChange={handlePermitirMinistrosChange}
                          className="w-4 h-4 ml-1 mr-2"
                      />
                      <label htmlFor="abm-ente_dependiente" className="text-sm font-medium">Esta iglesia permite tener ministros vinculados</label>
                 </div>
            </div>

            <div className="mt-6 border-b border-gray-300 pb-2"></div>

            <div className="mt-4">
                 <Typography variant="small" color="blue-gray" className="mb-3 font-medium">Registros administrativos asociados</Typography>
                 <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div className="flex items-center">
                           <Field id="abm-fich_culto" type="checkbox" disabled={esVisualizacion} name="fich_culto" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-fich_culto" className="text-sm">Fichero de culto</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-hab_municip" type="checkbox" disabled={esVisualizacion} name="hab_municip" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-hab_municip" className="text-sm">Habilitación municipal</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-libro_cont" type="checkbox" disabled={esVisualizacion} name="libro_cont" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-libro_cont" className="text-sm">Libros contables</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-seguro" type="checkbox" disabled={esVisualizacion} name="seguro" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-seguro" className="text-sm">Seguro</label>
                      </div>
                 </div>
            </div>

            <div className="mt-6 border-b border-gray-300 pb-2"></div>

            <div className="mt-4">
                 <Typography variant="small" color="blue-gray" className="mb-3 font-medium">Inmuebles asociados</Typography>
                 <div className="grid grid-cols-2 md:grid-cols-3 gap-y-3 gap-x-4">
                      <div className="flex items-center">
                           <Field id="abm-dispensario" type="checkbox" disabled={esVisualizacion} name="dispensario" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-dispensario" className="text-sm">Dispensarios</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-rehabilit" type="checkbox" disabled={esVisualizacion} name="rehabilit" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-rehabilit" className="text-sm">Centros de rehabilitación</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-colegio" type="checkbox" disabled={esVisualizacion} name="colegio" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-colegio" className="text-sm">Colegios</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-comedor" type="checkbox" disabled={esVisualizacion} name="comedor" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-comedor" className="text-sm">Comedores</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-hogar_niños" type="checkbox" disabled={esVisualizacion} name="hogar_niños" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-hogar_niños" className="text-sm">Hogares de niños</label>
                      </div>
                      <div className="flex items-center">
                           <Field id="abm-predio_recreat" type="checkbox" disabled={esVisualizacion} name="predio_recreat" className="w-4 h-4 mr-2" />
                           <label htmlFor="abm-predio_recreat" className="text-sm">Predios recreativos</label>
                      </div>
                 </div>
            </div>
        </div>
    );
};
